export default "__VITE_ASSET__BY6xty93__"